



























































































































import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/tool'
import Nav from './../Business/pages/components/Navs.vue'
import { findPayDrawmoneyListByCurrency, fundChangeListExport } from '../../api/transaction'
@Component({
  // 所有的组件选项都可以放在这里
  name: 'WithdrawRecord',
  components: {
    Nav
  }
})

export default class WithdrawRecord extends Vue {
  private navBarList = [
    {
      name: '商户中心',
      path: '/business/info'
    }
  ]

  formatDate = formatDate

  currency = ''

  private typeId: number | string = 1 // 数据类型 0 充值 1 提现

  date:string[] = []

  form = {
    content: '',
    merchant: '',
    id: ''
  }

  contentSelects = [
    { label: '全部', value: '' },
    { label: '全球货仓代收代付(充值)', value: 'T' },
    { label: '全球货仓代收代付(提现)', value: 'W' },
    { label: '支付', value: 'Pay' },
    { label: '退款', value: 'Cancel' }
  ]

  merchantSelects: any[] = []

  loading = false

  tableData: any[] = []

  currentPage = 1

  resultNum = 10

  total = 0

  get mchId () {
    return this.$store.state.User.userInfo.parentMchId
  }

  get disabledBtn () {
    return this.tableData.length === 0
  }

  // 切换当前页码
  handleCurrentChange (val: number): void {
    this.reset()
    this.currentPage = val
    this.findPayDrawmoneyListByCurrency()
  }

  handleSizeChange (val: number):void {
    console.log(`每页 ${val} 条`)
    this.findPayDrawmoneyListByCurrency()
  }

  // 选择日期
  handleChangeDate (value: string[]): void {
    console.log(value)
    this.findPayDrawmoneyListByCurrency()
  }

  // 重置
  reset (): void {
    this.currentPage = 1
    this.resultNum = 10
  }

  // 获取提现记录
  findPayDrawmoneyListByCurrency (): void {
    const params = {
      mchId: this.mchId,
      sdate: this.date[0],
      edate: this.date[1],
      currencyCode: this.currency,
      page: this.currentPage,
      resultNum: this.resultNum,
      typeId: this.typeId,
      treeId: this.typeId === 0 ? 'T' : 'W',
      autoCount: true
    }
    findPayDrawmoneyListByCurrency(params).then(res => {
      console.log(res, 'list 获取提现记录')
      this.loading = false
      if (res && res.results.length > 0) {
        // res.results.forEach(e => {
        //   const result = this.$precision(Number(e.totalFee / 100) + Number(e.currentBalance / 100))
        //   e.originBalance = this.$thousandNum(result)
        // })
        this.tableData = res.results.map((item: any) => {
          const result = this.$precision(Number(item.totalFee / 100) + Number(item.currentBalance / 100))
          item.originBalance = this.$thousandNum(result)
          return item
        })
        this.total = res.sizeAll
      }
    })
  }

  handleSearch (): void {
    this.findPayDrawmoneyListByCurrency()
  }

  clickExport (): void {
    fundChangeListExport({
      mchId: this.mchId,
      sdate: this.date[0],
      edate: this.date[1],
      currencyCode: this.currency,
      page: this.currentPage,
      resultNum: this.resultNum,
      typeId: this.typeId,
      treeId: this.typeId === 0 ? 'T' : 'W'
    }).then(res => {
      console.log(res)
      const blob = new Blob([res], { type: 'application/octet-stream' })
      const blobUrl = window.URL.createObjectURL(blob)
      const fileName = `全球货仓代收代付(提现)记录列表_${this.date[0]}-${this.date[1]}.xlsx`
      const a = document.createElement('a')
      a.style.display = 'none'
      a.download = fileName // 文件名
      a.href = blobUrl
      a.click()
    })
  }

  mounted (): void {
    const { currency, typeId } = this.$route.query
    if (typeof currency !== 'undefined') {
      this.currency = currency.toString()
    }
    if (typeof typeId === 'string') {
      this.typeId = Number(typeId)
      document.title = Number(typeId) === 0 ? '全球货仓代收代付(充值)记录' : ' 全球货仓代收代付(提现)记录'
    }
    const now = new Date().getTime()
    const defaultEdate = formatDate(now, 'Y-M-D')
    const time = 6 * 24 * 60 * 60 * 1000
    const defaultSdate = formatDate(now - time, 'Y-M-D')
    this.date = [defaultSdate, defaultEdate]
    this.findPayDrawmoneyListByCurrency()
  }
}

